import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { EMPTY_FIELD } from 'support/helpers/const/const';
import { formatCurrency } from 'support/helpers/currency/currency';
import { PaymentReconciliationDetailsData } from 'pages/PaymentReconciliation/PaymentReconciliationDetails/types';
import { SidebarSection } from 'components/Sidebar/SidebarSection/SidebarSection';
import { SidebarTableContent } from 'components/Sidebar/SidebarTableContent/SidebarTableContent';

export const PaymentReconciliationSummary = ({
  paymentReconciliation,
}: {
  paymentReconciliation: PaymentReconciliationDetailsData['data'];
}) => {
  const { t } = useTranslation();
  const formatValue = useCallback(
    (amount: number | undefined) => {
      if (amount === undefined) {
        return EMPTY_FIELD;
      }
      const currency = paymentReconciliation.currency;
      return formatCurrency(amount, currency);
    },
    [paymentReconciliation.currency],
  );

  const summary = {
    content: [
      [
        {
          key: 'subtotal',
          label: t('paymentReconciliation:detailPage.summary.subtotal'),
          value: formatValue(paymentReconciliation.due_amount),
        },
        {
          key: 'corrections',
          label: t('paymentReconciliation:detailPage.summary.corrections'),
          value: formatValue(paymentReconciliation.correction_amount),
        },
      ],
    ],
    footer: {
      label: t('paymentReconciliation:detailPage.summary.remittedAmount'),
      value: formatValue(paymentReconciliation.remitted_amount),
    },
  };
  return (
    <SidebarSection>
      <SidebarTableContent sections={summary.content} footer={summary.footer} />
    </SidebarSection>
  );
};
